import { userlang } from "../../i18n/i18n";
import {
  AnalyticsUtilsAbstract,
  AppParams,
  IUacBackendInfo
} from "@traceair/browser-tracking-lib";

// @ts-ignore
const { version } = require("../../../package");

let analytics: SigninPageAnalytics | undefined;

export class SigninPageAnalytics extends AnalyticsUtilsAbstract {
  enabled: boolean = false;
  env: string = "";
  backendUrl: string = "";
  constructor(lang: string) {
    super(lang);
  }

  getAppParams() {
    return {
      componentVersion: version,
      component: "Signin Page",
      componentData: {},
      subsystem: "CSU",
      env: this.env
    } as AppParams;
  }

  protected async getBackendInfo(): Promise<IUacBackendInfo> {
    return { url: `${this.backendUrl}/api/store-action` };
  }

  async track(eventMsg: string = "uncorrect event", params: any = {}) {
    super.track(`(login page) ${eventMsg}`, params);
  }

  getJwt(): string | null {
    return null;
  }

  static userShouldBeTracked() {
    return true;
  }

  init(params: { enabled: boolean; backendUrl: string; env: string }) {
    const { enabled, env, backendUrl } = params;
    this.enabled = enabled;
    this.env = env;
    this.backendUrl = backendUrl;
    super.setSessionId();
  }

  static setup(enabled: boolean, backendUrl: string, env: string) {
    if (!enabled) {
      return;
    }

    analytics = new SigninPageAnalytics(userlang);
    analytics.init({ enabled, backendUrl, env });
  }

  isEnabled() {
    return this.enabled;
  }
}

function trackAction(eventMsg: string = "uncorrect event", params: any = {}) {
  if (!analytics) {
    throw new Error("analytics system is not initialized");
  }
  analytics.track(eventMsg, params);
}

export default trackAction;
